/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Basic } from 'components/Modals';
import {
  Container, Row,
} from 'globalStyle';

import { Title, Text } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import { routes } from 'routes';

export const CompleteProfileModal = ({
  handleClick,
  isLogin = false,
  ...rest
}) => {
  if (!isLogin) return null;
  return (
    <Basic
      isBackground
      width={560}
      handleClick={handleClick}
      zIndex={10}
      {...rest}
    >
      <Title mb={30} number={2} isCenter>¡Estás a un paso de invertir!</Title>
      <Container width="65%">
        <Text
          mb={50}
          number={1}
          isCenter
        >
          Para continuar, ayúdanos llenando algunos datos sobre ti.

        </Text>
      </Container>
      <Row mb={50} isCenter>
        <Hollow
          medium
          href={routes.profile.route}
          onClick={handleClick}
        >
          Completa la información
        </Hollow>
      </Row>
    </Basic>
  );
};
